import VodDetails from '@/features/VOD/vodClasses/vodDetails'
import React, { createContext, FC, ReactNode, useContext } from 'react'
import { getUseVodItemsDetails } from '@/shared/getContainer/getUseVodItemsDetails'

interface IUseVODDetails {
    details: VodDetails | null
    getItemDetails: (
        item: {
            productId: string | null
            assetType: string | undefined
            id: string
            serviceName?: string
        },
        isForceFetchDetails?: boolean
    ) => void
    error: unknown
}

type ContainerProviderProps = {
    children: ReactNode
}

const GetVodDetailsContext = createContext<IUseVODDetails | undefined>(
    undefined
)

const useGetVodDetailsContext = () => {
    const context = useContext(GetVodDetailsContext)
    if (context === undefined) {
        throw new Error(
            'useGetVodDetailsContext must be used within a GetVODDetailsProvider'
        )
    }
    return context
}

const useItemDetails = await getUseVodItemsDetails()

const GetVODDetailsProvider: FC<ContainerProviderProps> = ({ children }) => {
    const { details, getItemDetails, error } = useItemDetails()

    return (
        <GetVodDetailsContext.Provider
            value={{ details, getItemDetails, error }}>
            {children}
        </GetVodDetailsContext.Provider>
    )
}

export { useGetVodDetailsContext, GetVODDetailsProvider }
